export default __webpack_public_path__ + "static/media/vaccination_lock.f4844595.png";